/* eslint-disable jira/import-whitelist */
import type { PreloadedQuery } from 'react-relay';
import { JiraViewAri } from '@atlassian/ari/jira';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import type { JiraPlanDataRestResponse } from '@jira/software__backlog-uif-types/src/SrcJiraPlanDataRestResponse.tsx';
import parameters from '@jira/spa-apps__next-gen-backlog/src/__generated__/ViewSettingsDataResolverQuery$parameters.ts';
import type { ViewSettingsDataResolverQuery } from '@jira/spa-apps__next-gen-backlog/src/__generated__/ViewSettingsDataResolverQuery.graphql.ts';
import { NEXTGEN_BACKLOG_REST_RESOURCE } from './nextgenBacklogRestResource.constants.tsx';

export const uifBacklogResource: RouteResource<JiraPlanDataRestResponse | null> =
	createResource<JiraPlanDataRestResponse | null>({
		type: NEXTGEN_BACKLOG_REST_RESOURCE,
		getKey: ({
			match: {
				params: { boardId },
			},
			query: { config },
		}) =>
			/*
            When navigating to and from the board settings page we need
            the data to get reloaded. So we are updating the key to force a refresh
        */
			['uif-backlog-data']
				.concat(boardId ?? '')
				.concat(config ? `config-${config}` : '')
				.filter(Boolean)
				.join('-'),
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-nextgen-plandata-rest", jiraSpaEntry: "async-nextgen-plandata-rest" */ './getData.tsx'
			),
		// Setting mexAge to 0 so it will get the data again after coming back from a config page
		maxAge: 0,
	});

const getQuery: Parameters<
	typeof createRelayResource<ViewSettingsDataResolverQuery>
>[0]['getQuery'] = ({ match }, { tenantContext: { activationId, cloudId } }) => {
	const viewId = JiraViewAri.create({
		activationId,
		siteId: cloudId,
		scopeId: `${Number(match.params.boardId)}/backlog`,
		scopeType: 'board',
	}).toString();

	return {
		options: {
			fetchPolicy: 'network-only' as const,
		},
		parameters,
		variables: {
			input: {
				jiraBacklogViewQueryInput: {
					viewId,
				},
			},
		},
	};
};

export const backlogCMPViewSettingsResource: RouteResource<
	PreloadedQuery<ViewSettingsDataResolverQuery, Record<string, unknown>>
> = createRelayResource<ViewSettingsDataResolverQuery>({
	type: 'BACKLOG_CMP_VIEW_SETTINGS_RESOURCE',
	getQuery,
});
